'use client'

import { Close } from '../../icons'
import { Backdrop } from '../Backdrop'
import { Carousel, CarouselProps } from '../Carousel'
import { CloseButton } from './styles'

export interface LightboxProps extends Omit<CarouselProps, 'autoHeight'> {
  /**
   * Lightbox open state
   */
  open: boolean

  /**
   * onClose handler
   */
  onClose: () => void

  /**
   * Image height
   */
  height?: number | string
}

export const Lightbox = ({
  open,
  onClose,
  height = '70vh',
  ...carouselProps
}: LightboxProps) => {
  return (
    <Backdrop open={open} opacity={0.8} onClick={onClose}>
      <CloseButton aria-label="閉じる" onClick={onClose}>
        <Close />
      </CloseButton>
      <Carousel {...carouselProps} height={height} />
    </Backdrop>
  )
}
